
import { computed } from "vue";
import { useRoute } from "vue-router";

const defaultLayout = "default";

// Adding some comments before removing the project

export default {
  components: {},
  setup() {
    const route = useRoute();
    const layout = computed(
      () => `${route.meta.layout || defaultLayout}-layout`
    );

    return { layout };
  },
};
